import React, {Component} from 'react';
import server from '../../server';

class AppointmentBox extends Component{
    state={
        fisioterapistData:{}
    }

    componentWillMount(){
        server.get("users/" + this.props.data.fisioterapistId,(data) =>{
            this.setState({fisioterapistData: data})
        });
    }

    render(){
        return(
            <div class="bdB pT-20">
                <div class="w-100p peers jc-sb">
                    <div>
                        <h5 class="m-0"><b>{this.props.data.date}</b></h5>
                        <p class="c-client-secondary fsz-sm">{this.props.data.clinic ? "Clínica" : "Domiciliar"}</p>
                    </div>
                    <div class="peers">
                        <img class="fisio-foto mR-10" src="https://randomuser.me/api/portraits/men/10.jpg"
                            alt=""/>
                        <div>
                            <p class="m-0 fsz-xs c-client-default h12">Fisioterapeuta</p>
                            <p class="p-0 m-0">{this.state.fisioterapistData.name}</p>
                        </div>
                    </div>
                </div>
                <div class="expand-block expand">
                    <div class="w-100p pX-10 pY-5 ai-c">
                        <div class="fsz-xs c-client-default">Comentário
                            fisioterapeuta</div>
                        <p>{this.props.data.commentary_patient}</p>
                        <div class="fsz-xs c-client-default">Fotos e vídeos</div>
                        <div class="client-midias mT-5">
                            <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                alt=""/>
                            <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                alt=""/>
                            <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                alt=""/>
                            <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                alt=""/>
                            <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                alt=""/>
                            <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                alt=""/>
                        </div>
                    </div>
                    {/**<div class="form-group col-xs-12 mT-20">
                        <label for="inputCep">Comentário para o fisioterapeuta</label>
                        <textarea class="form-control" rows="2" name="toDoctor"
                            placeholder="Algum comentário para o fisioterapeuta?" />
                        </div>
                        <div class="form-group ta-c col-xs-12">
                            <button class="btn btn-client-default" type="button">Responder</button>
                        </div>**/}
                </div>
            </div>
        )
    }
}

class AllAppointment extends Component{
    state={
        boxes:[]
    }

    loadAppointments = (apps) =>{
        let content = [];
        apps.forEach(app => {
            if(app.status == 1 && app.id != this.props.latestAppointment.id)
                content.push(<AppointmentBox data={app}/>);
        });

        this.setState({boxes:content});
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.appointments != null)
            this.loadAppointments(nextProps.appointments);
    }

    render(){
        return(
            <div class="form-group col-md-6">
                <div class="clearfix"></div>
                <div class="w-100p peers jc-sb  mT-20">
                    <h4 class="c-client-default">( {this.state.boxes.length} ) Outros atendimentos</h4>
                    <button type="button" class="expand-button btn btn-clear pX-5 pY-0  bdrs-2 cur-p c-client-default">
                        <i class="material-icons">expand_more</i>
                    </button>

                </div>
                {this.state.boxes}                       
            </div>
        )
    }
}

export default AllAppointment;


// WEBPACK FOOTER //
// ./src/pages/evolution/AllAppointments.js